import React from 'react'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import ParameterButton from './ParameterButton'

interface TutorialButtonProps {
  handleBack?: () => void
}

const TutorialButton = ({ handleBack }: TutorialButtonProps): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)

  const handleClick = (): void => {
    handleBack?.()
  }

  return (
    <ParameterButton
      title={translation.common.tutorial}
      icon='tutorial'
      onClick={handleClick}
    />
  )
}

export default TutorialButton
